<template>
  <div class="sr-result">
    <!-- No results -->
    <div
      class="no-search-result"
      v-if="
      searchResults.inbox.length === 0 &&
      searchResults.draft.length === 0 &&
      searchResults.sent.length === 0 &&
      searchResults.trash.length === 0"
    >
      No results
    </div>

    <!-- Inbox -->
    <template v-if="searchResults.inbox.length > 0">
      <h4>Inbox:</h4>
      <div
        class="sr-result-list"
        v-for="ib in searchResults.inbox"
        :key="ib.mailBoxID"
        @click="goToMailDetailPage('inbox', ib.mailBoxId)"
      >
        <div class="email-quick-view">
          <div class="sender-info">
            <div class="email-sender-name">{{ ib.from }}</div>
            <div class="email-sent-time">{{ ib.time }}</div>
          </div>
          <div class="email-subject">{{ ib.sub }}</div>
        </div>
      </div>
    </template>

    <!-- Draft -->
    <template v-if="searchResults.draft.length > 0">
      <h4>Draft:</h4>
      <div
        class="sr-result-list"
        v-for="ib in searchResults.draft"
        :key="ib.mailBoxID"
        @click="goToMailDetailPage('draft', ib.mailBoxId)"
      >
        <div class="email-quick-view">
          <div class="email-subject">{{ ib.sub }}</div>
          <div class="sender-info">
            <div class="email-sender-name">{{ ib.from }}</div>
            <div class="email-sent-time">{{ ib.time }}</div>
          </div>
        </div>
      </div>
    </template>

    <!-- sent -->
    <template v-if="searchResults.sent.length > 0">
      <h4>Sent:</h4>
      <div
        class="sr-result-list"
        v-for="ib in searchResults.sent"
        :key="ib.mailBoxID"
        @click="goToMailDetailPage('sent', ib.mailBoxId)"
      >
        <div class="email-quick-view">
          <div class="sender-info">
            <div class="email-sender-name">{{ ib.to }}</div>
            <div class="email-sent-time">{{ ib.time }}</div>
          </div>
          <div class="email-subject">{{ ib.sub }}</div>
        </div>
      </div>
    </template>

    <!-- trash -->
    <template v-if="searchResults.trash.length > 0">
      <h4>Trash:</h4>
      <div
        class="sr-result-list"
        v-for="ib in searchResults.trash"
        :key="ib.mailBoxID"
        @click="goToMailDetailPage('trash', ib.mailBoxId)"
      >
        <div class="email-quick-view">
          <div class="sender-info">
            <div class="email-sender-name">{{ ib.from }}</div>
            <div class="email-sent-time">{{ ib.time }}</div>
          </div>
          <div class="email-subject">{{ ib.sub }}</div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

export default {
  props:{
    searchResults: Object
  },
  methods: {
    goToMailDetailPage(boxType, mailBoxId) {
      this.$router.push(`/emails/${boxType}/${mailBoxId}`);
    }
  }
};
</script>

<style scoped>
.no-search-result {
  display: block;
}
</style>
